import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'
import { buildEntitiesFromDescriptionPrompt } from '@/ai/prompts'

export const generateEntitiesFromDescription = async ({
  workflow,
  cardTypes,
  userDescription,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildEntitiesFromDescriptionPrompt({
    workflow,
    cardTypes,
    userDescription,
    stream
  })

  if (stream) {
    return await streamJsonResponses({
      messages,
      useCase: 'entities',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'entities',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
